/**
 * Account-level gate for the campaign activity item's Result section — the raw
 * response JSON and its "Download JSON" button.
 *
 * Super admins always see it. Every other role sees it only where the account
 * has opted in via the `enable-result-section` setting (boolean-string
 * convention, same as `enable-v3-ui`). Absent or any value other than 'true'
 * keeps it hidden, so the default for every existing account is unchanged.
 *
 * Unlike `enable-campaign-result-zip-download`, this flag is NOT restricted to
 * account admins: when it is on, every role on the account can read what a run
 * returned.
 *
 * Note this gates the JSON body only. The readable parts of the section — the
 * errors and warnings lists, the plain-language summary, and the artifact
 * downloads — are visible to everyone regardless of this flag.
 */
export const RESULT_SECTION_KEY = 'enable-result-section';

export function isResultSectionSharedWithAccount(accountSettings) {
  return accountSettings?.[RESULT_SECTION_KEY] === 'true';
}
